// extracted by mini-css-extract-plugin
export default {"modal":"ER-z","error":"FR-z","disabled":"GR-z","fields":"HR-z","errorMsg":"IR-z","footer":"JR-z","formContentWrapper":"KR-z","productImage":"LR-z","overlay":"MR-z"};